import TiptapHeading from '@tiptap/extension-heading';
import classNames from 'classnames';
import {TypographySize, typographyStyles} from 'packages/ui-kit';
import {sendToStatist} from 'packages/statist';
import type {Editor} from '@tiptap/core';

import appStyles from '../app-post-style.module.css';

const TAG_TO_HEADING_TYPOGRAPHY = {
    h1: TypographySize.Heading3,
    h2: TypographySize.Heading4,
    h3: TypographySize.Heading6,
};

export type AvailableLevels = [1, 2, 3];

export const AVAILABLE_LEVELS: AvailableLevels = [1, 2, 3];

export const getHeadingLevelActive = (editor?: Editor) => {
    for (const level of AVAILABLE_LEVELS) {
        if (editor?.isActive('heading', {level})) {
            return level;
        }
    }
};

export const TimeWebkitHeadingExtension = TiptapHeading.extend({
    marks: 'italic strike link code',
    renderHTML({node, HTMLAttributes}) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level: 1 | 2 | 3 = hasLevel ? node.attrs.level : 3;
        const tag = `h${level}` as const;

        return [
            tag,
            {
                ...HTMLAttributes,
                class: classNames([
                    HTMLAttributes.class,
                    typographyStyles.base,
                    typographyStyles['base-color'],
                    typographyStyles[TAG_TO_HEADING_TYPOGRAPHY[tag]],
                    appStyles.markdown__heading,
                ]),
            },
            0,
        ];
    },
    addKeyboardShortcuts() {
        return this.options.levels.reduce((items, level) => ({
            ...items,
            ...{
                [`Ctrl-Shift-${level}`]: () => {
                    if (this.editor.isActive('table') || this.editor.isActive('codeBlock')) {
                        return;
                    }
                    this.editor.commands.toggleHeading({level});
                    sendToStatist('editor.format.tap', {formatType: `header${level as AvailableLevels[number]}`, hotkey: true});
                },
            },
        }), {});
    },
    addInputRules() {
        return (this.parent?.() ?? []).map((rule) => ({
            ...rule,
            handler: (props) => {
                if (this.editor.isActive('table')) {
                    return;
                }
                return rule.handler(props);
            },
        }));
    },
}).configure({
    levels: AVAILABLE_LEVELS,
});
